<section
  class="container lg:mb-0 px-4xs lg:pt-6xl lg:px-7xl font-inter font-medium"
>
  <article
    class="col-span-12 flex flex-col lg:flex-row pt-2xl lg:pt-4xs"
    [class.bg-vp-container-brand]="isBlueVariant"
  >
    <div
      class="px-l lg:w-1/2 lg:pt-5xl lg:pr-7xl lg:pl-6xl"
      [class.bg-vp-container-brand]="isBlueVariant"
      [class.text-white]="isBlueVariant"
      [class.lg:order-2]="isTextRightPosition"
    >
      <h2 class="mb-l text-2xl font-semibold">{{ section.title }}</h2>

      <div class="mb-l" [innerHtml]="section.content"></div>

      <app-cms-link
        *ngIf="hasLink"
        [isExternalLink]="section.is_external_link"
        [isMobile]="isMobileDevice"
        [url]="section.link_url"
        [variant]="vtmnPlayVariant.SECONDARY"
        [shape]="
          isMobileDevice
            ? vtmnPlayButtonShape.SQUARED
            : vtmnPlayButtonShape.ROUNDED
        "
        [text]="section.link_label"
      ></app-cms-link>
    </div>
    <div
      class="w-full lg:w-1/2 mt-2xl lg:mt-4xs aspect-square md:aspect-[3/2]"
      [class.lg:order-1]="isTextRightPosition"
    >
      <img
        [alt]="alt"
        [src]="imageSrc"
        loading="lazy"
        class="aspect-square w-full md:aspect-[3/2] object-cover"
      />
    </div>
  </article>
</section>
